@switch (state()) {
  @case ('loading') {
    @if (showBlockingStates()) {
      <tui-loader class="my-10" size="l" />
    }
  }
  @case ('forbidden') {
    @if (showBlockingStates()) {
      <x-empty-block [title]="'workflows.screen_state.forbidden' | translate" />
    }
  }
  @case ('not-found') {
    @if (showBlockingStates()) {
      <x-empty-block [title]="'workflows.screen_state.not_found' | translate" />
    }
  }
  @case ('unavailable') {
    @if (showBlockingStates()) {
      <x-empty-block
        [title]="'workflows.screen_state.unavailable' | translate"
      />
    }
  }
  @case ('stale-offline') {
    <div tuiNotification size="m" appearance="warning" class="mb-4">
      {{ 'workflows.screen_state.stale_offline' | translate }}
    </div>
  }
  @case ('sync-pending') {
    <div tuiNotification size="m" appearance="info" class="mb-4">
      {{
        'workflows.screen_state.sync_pending'
          | translate: { count: pendingWork().pending }
      }}
    </div>
  }
  @case ('sync-failed') {
    @if (pendingWork().unknown) {
      <div tuiNotification size="m" appearance="negative" class="mb-4">
        {{ 'workflows.pending_state_unknown' | translate }}
      </div>
    } @else {
      <div tuiNotification size="m" appearance="negative" class="mb-4">
        <p>
          {{
            'workflows.screen_state.sync_failed'
              | translate: { count: pendingWork().failed }
          }}
        </p>
        <ul class="mt-2 list-disc ps-5 typo-body-s">
          @for (item of pendingWork().items; track $index) {
            @if (item.status === 'failed') {
              <li>
                {{ 'workflows.screen_state.item_' + item.kind | translate }}
                @if (item.error) {
                  — {{ item.error }}
                }
              </li>
            }
          }
        </ul>
        <button
          tuiButton
          type="button"
          size="s"
          appearance="secondary"
          class="mt-3"
          (click)="retry.emit()"
        >
          {{ 'workflows.screen_state.retry' | translate }}
        </button>
      </div>
    }
  }
}
